export default {
  address: "address",
  backoffice: "backoffice",
  document: "document",
  client: "client",
  company: "company",
} as const;
